<template>
  <div id="Setting" class="bg-color1" style="height:calc(100vh);">
    <div ref="app_head" class="col-12 lh40 bg-color-white b-s-2 pl5 pr5 fixed-t">
        <div class="col-3 f18" @click="$router.back(-1)"><i class="iconfont icon-31fanhui1 color-primary"></i></div>
        <div class="col-6 t-c color-primary"><span class="f24 fw">A</span>juste</div>
        <div class="col-3 t-r f26"></div>
    </div>
    <div class="h4"></div>
    <div class="col-12 mt8">
      <div class="col-12 bg-color-white f14 pl8 pr8">
        <div class="col-12 lh50 bb1">
          <div class="col-4 t-l color-muted">Notificación</div>
          <div class="col-8 t-r f36" @click="switch_notify()">
            <i class="iconfont icon-kaiguan4 color-primary" v-if="pageData.notify_push == 1"></i>
            <i class="iconfont icon-kaiguan3 color-muted" v-else></i>
          </div>
        </div>
        <div class="col-12 lh50 bb1">
          <div class="col-4 t-l color-muted">Almacenes</div>
          <div class="col-8 t-r f16 t-r" @click="go_warehouse_setting()">
            <i class="iconfont icon-31fanhui2"></i>
          </div>
        </div>
        <!-- Open API -->
        <div class="col-12 lh50 bb1">
          <div class="col-4 t-l color-muted">Open API</div>
          <div class="col-8 t-r f16 t-r" @click="go_open_api()">
            <i class="iconfont icon-31fanhui2"></i>
          </div>
        </div>
        <!-- 重置数据 -->
        <div class="col-12 lh50 bb1">
          <div class="col-4 t-l color-muted">Restablecer datos</div>
          <div class="col-8 t-r f16 t-r" @click="go_reset()">
            <i class="iconfont icon-31fanhui2"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Setting',
  data () {
    return {
      pageData: {}
    }
  },
  created: function () {
    this.get_pageData();
  },
  methods: {
    save: function () {
      let post_data = {}
      post_data.notify_push = this.pageData.notify_push
      this.post(this.api_url + 'manage/account_setting_update',post_data,true).then((res)=>{
        if(res.status == 1){
          this.$store.commit('setAlert',{type:'success',msg: "Success"});
        }else{
          this.$store.commit('setAlert',{type:'error',msg: "Error"});
        }
      });
    },
    get_pageData: function () {
      this.post(this.api_url + 'manage/account_setting','',true).then((res)=>{
        if(res.status == 1){
          this.pageData = res.data;
        }else{
          this.$store.commit('setAlert',{type:'error',msg: "Error"});
        }
      });
    },
    // 通知开关
    switch_notify: function () {
      if(this.pageData.notify_push == 1){
        this.pageData.notify_push = 0;
      }else{
        this.pageData.notify_push = 1;
      }
      this.save();
    },
    // 仓库设置
    go_warehouse_setting: function () {
      this.$router.push({name: 'M_MWarehouseSetting'});
    },
    // Open API
    go_open_api: function () {
      this.$router.push({name: 'M_OpenApi'});
    },
    // 重置数据
    go_reset: function () {
      this.$router.push({name: 'M_Reset'});
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Main/Setting.vue